module.exports = __webpack_public_path__ + "static/media/GESSTwo900.19da86ec.woff";